import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FormSection, Form } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { required, MultiselectView, ParkingFilter2, StyledField, DarkMultiselect } from 'libs/form';
import { Tarrificator } from '../tarifficators/tarifficator';
import { FormHeader, SaveButton, TariffData } from '../../styledComponents';
import { SectionTitle, TwoFields } from './tariff-form-main.styled';
import { validate } from '../validation';

const NewTariffFormForm = (props) => {
  const { onSubmit, vehicleClasses, categories, tarrificatorParams /*, initialize, resetn*/ } = props;
  const { t } = useTranslation();
  const validateP = useCallback(required(t), [t]);

  // useEffect(() => {
  // resetForm();
  // initialize(props.initialValues);
  // }, [resetn]);

  return (
    <Form onSubmit={props.handleSubmit(onSubmit)}>
      <TariffData>
        <FormHeader>{t('form.Данные тарифа')}</FormHeader>

        <StyledField type="select" label={t('dict_filter.Тип')} name="type" disabled={true} className="disabled">
          <option value="individual">{t('grid.Индивидуальный')}</option>
        </StyledField>
        <ParkingFilter2 dark />
        <StyledField validate={validateP} placeholder={t('grid.Осень 2017')} type="text" label={t('grid.Название *')} name="name" />
        <DarkMultiselect
          validate={validateP}
          type="multiselect"
          label={t('form.Класс ТС *')}
          name="vehicle_class"
          placeholder={t('form.Выберите класс ТС')}
          data={vehicleClasses}
          additionalComponent={MultiselectView}
          autoWidth={false}
        />
        <DarkMultiselect
          // validate={validateP}
          type="multiselect"
          label={t('form.Категория')}
          name="vehicle_category"
          placeholder={t('form.Выберите категорию ТС')}
          data={categories}
          additionalComponent={MultiselectView}
          autoWidth={false}
        />
        <StyledField className="shortfield" validate={validateP} placeholder={t('form.08 11 2017')} type="dateTime" label={t('grid.Начало *')} name="time_from" />

        <StyledField type="text" placeholder={t('form.15 мин')} label={t('form.Время на выезд')} name="time_to_leave" mask={{ suffix: t('form.мин') }} />

        <SectionTitle>{t('sections.Абонемент')}</SectionTitle>
        <StyledField type="text" placeholder={t('form.Цена абонемента')} label={t('form.Цена абонемента')} name="subscription_amount" mask={{ suffix: t('form.руб') }} />
        <TwoFields>
          <StyledField type="text" placeholder={'30'} label={t('form.Срок действия')} name="subscription_period" mask={{ suffix: '' }} />
          <StyledField type="select" label="" name="subscription_period_unit" onlyInput>
            <option value="days">{t('units.дней')}</option>
            <option value="months">{t('units.месяцев')}</option>
          </StyledField>
        </TwoFields>

        <SectionTitle>{t('form.Повторный въезд')}</SectionTitle>
        <StyledField type="text" placeholder={t('form.15 мин')} label={t('form.Повторный платный въезд')} name="secondentry_interval" mask={{ suffix: t('form.мин') }} />
      </TariffData>

      <FormSection name="zones">
        <Tarrificator {...tarrificatorParams} />
      </FormSection>

      <SaveButton disabled={props.submitting} />
    </Form>
  );
};

NewTariffFormForm.propTypes = {
  onSubmit: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  tarrificatorParams: PropTypes.any.isRequired,
  categories: PropTypes.any.isRequired,
  vehicleClasses: PropTypes.any.isRequired,
  handleSubmit: PropTypes.any.isRequired,
};

export const NewTariffForm = reduxForm({
  form: 'newTariffForm',
  // initialValues,
  validate,
  // enableReinitialize: true,
})(NewTariffFormForm);
